export const CONFIG_ENVOLVENTE_MIN_AREA_TRABAJO = [
    [-72.7065, 9.8499], 
    [-72.6958, 9.8499], 
    [-72.6958, 9.8743], 
    [-72.7065, 9.8743], 
    [-72.7065, 9.8499]
];

export const COORDENADAS_LOTES = [
  // --- POLIGONO 1 ---
  [[
    [-72.7001, 9.8531], [-72.7004, 9.8532], [-72.7004, 9.8536], [-72.7003, 9.854],
    [-72.7003, 9.8546], [-72.6989, 9.8553], [-72.6984, 9.8556], [-72.6985, 9.8558],
    [-72.6993, 9.8558], [-72.6994, 9.8554], [-72.7, 9.8553], [-72.7007, 9.8556],
    [-72.7008, 9.8559], [-72.7008, 9.857], [-72.7002, 9.8581], [-72.7005, 9.858],
    [-72.7008, 9.8581], [-72.7009, 9.8587], [-72.7009, 9.8597], [-72.7011, 9.8603],
    [-72.7009, 9.8605], [-72.701, 9.8608], [-72.701, 9.8618], [-72.7004, 9.8622],
    [-72.7001, 9.862], [-72.6998, 9.8617], [-72.6994, 9.8623], [-72.6997, 9.8621],
    [-72.7, 9.8622], [-72.7, 9.8629], [-72.7002, 9.8631], [-72.7002, 9.8635],
    [-72.7001, 9.8639], [-72.7005, 9.8639], [-72.7007, 9.8641], [-72.701, 9.8646],
    [-72.7014, 9.865], [-72.7016, 9.8653], [-72.702, 9.8656], [-72.702, 9.8659],
    [-72.7018, 9.8659], [-72.7019, 9.8663], [-72.7017, 9.8667], [-72.7014, 9.867],
    [-72.7013, 9.8671], [-72.701, 9.8673], [-72.7012, 9.8679], [-72.7011, 9.869],
    [-72.7013, 9.8699], [-72.7011, 9.8701], [-72.6994, 9.8676], [-72.6973, 9.8643],
    [-72.6969, 9.8637], [-72.6964, 9.8627], [-72.6966, 9.8623], [-72.6975, 9.8618],
    [-72.6977, 9.8619], [-72.6977, 9.8622], [-72.6978, 9.8622], [-72.6979, 9.8616],
    [-72.6987, 9.8613], [-72.6983, 9.861], [-72.6977, 9.8595], [-72.6979, 9.8593],
    [-72.6982, 9.8592], [-72.6984, 9.8592], [-72.699, 9.8591], [-72.6985, 9.8591],
    [-72.6982, 9.8592], [-72.6976, 9.8591], [-72.6974, 9.8588], [-72.6971, 9.8585],
    [-72.6972, 9.8577], [-72.6973, 9.8575], [-72.6975, 9.8574], [-72.6979, 9.8571],
    [-72.6984, 9.8565], [-72.6979, 9.8567], [-72.6976, 9.8573], [-72.6973, 9.8574],
    [-72.6971, 9.8573], [-72.697, 9.8564], [-72.6974, 9.855], [-72.6984, 9.8542],
    [-72.6984, 9.8535], [-72.6987, 9.8535], [-72.6988, 9.8534], [-72.6994, 9.8531],
    [-72.6993, 9.8526], [-72.6987, 9.8534], [-72.6984, 9.8535], [-72.6981, 9.8533],
    [-72.698, 9.8529], [-72.6982, 9.8524], [-72.6983, 9.8523], [-72.6987, 9.8522],
    [-72.6989, 9.8519], [-72.699, 9.8517], [-72.6991, 9.8516], [-72.6988, 9.8517],
    [-72.6985, 9.8519], [-72.6984, 9.8517], [-72.6989, 9.8507], [-72.6993, 9.8505],
    [-72.6996, 9.8506], [-72.6996, 9.8512], [-72.6999, 9.8511], [-72.7001, 9.851],
    [-72.7003, 9.8512], [-72.7005, 9.8513], [-72.7003, 9.8518], [-72.7, 9.8519],
    [-72.7003, 9.8521], [-72.7004, 9.8527], [-72.7001, 9.8531]
  ]],

  // --- POLIGONO 2 ---
  [[
    [-72.7028, 9.8516], [-72.7037, 9.8533], [-72.7045, 9.8553], [-72.7046, 9.8557],
    [-72.7044, 9.856], [-72.7041, 9.8562], [-72.704, 9.8566], [-72.704, 9.857],
    [-72.7038, 9.8572], [-72.7038, 9.8573], [-72.7044, 9.8577], [-72.7049, 9.858],
    [-72.7053, 9.8585], [-72.7057, 9.8596], [-72.7058, 9.8609], [-72.7059, 9.8622],
    [-72.7059, 9.8634], [-72.7057, 9.8636], [-72.7055, 9.8634], [-72.7053, 9.8638],
    [-72.7049, 9.864], [-72.7051, 9.8644], [-72.7053, 9.8646], [-72.7057, 9.8644],
    [-72.7059, 9.8645], [-72.706, 9.8654], [-72.706, 9.8656], [-72.7061, 9.8657],
    [-72.7063, 9.8676], [-72.7064, 9.8701], [-72.7059, 9.871], [-72.7057, 9.8712],
    [-72.7063, 9.8715], [-72.7065, 9.8718], [-72.7065, 9.8723], [-72.7042, 9.8738],
    [-72.7035, 9.8739], [-72.7023, 9.8721], [-72.7022, 9.8709], [-72.7022, 9.8698],
    [-72.7025, 9.8692], [-72.7023, 9.869], [-72.7023, 9.8684], [-72.7025, 9.8682],
    [-72.7025, 9.8672], [-72.7028, 9.8669], [-72.7029, 9.8662], [-72.7029, 9.8652],
    [-72.7029, 9.8644], [-72.7026, 9.8641], [-72.7027, 9.8628], [-72.7026, 9.8621],
    [-72.7026, 9.8611], [-72.7028, 9.8608], [-72.7028, 9.8603], [-72.7029, 9.8575],
    [-72.7029, 9.8571], [-72.7033, 9.8567], [-72.7029, 9.8568], [-72.7026, 9.8564],
    [-72.7023, 9.8563], [-72.702, 9.8565], [-72.7016, 9.8563], [-72.7012, 9.8556],
    [-72.7008, 9.8552], [-72.7007, 9.8546], [-72.7008, 9.8539], [-72.701, 9.8539],
    [-72.7018, 9.8547], [-72.7019, 9.8545], [-72.7023, 9.8544], [-72.7022, 9.8542],
    [-72.7024, 9.8538], [-72.7023, 9.8533], [-72.7024, 9.8528], [-72.7019, 9.8528],
    [-72.7015, 9.8526], [-72.7013, 9.8521], [-72.7012, 9.8514], [-72.7014, 9.8512],
    [-72.7017, 9.8512], [-72.7023, 9.8512], [-72.7028, 9.8516]
  ]]
];